"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const SvgIcon_1 = __importDefault(require("@mui/material/SvgIcon"));
function GridViewIcon(_a) {
    var { stroke = 'currentColor', fill = 'transparent' } = _a, props = __rest(_a, ["stroke", "fill"]);
    return (react_1.default.createElement(SvgIcon_1.default, Object.assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), react_1.default.createElement("rect", { x: "3.5", y: "4", width: "7", height: "7", rx: "2.5", fill: fill, stroke: stroke, strokeWidth: "1.5" }), react_1.default.createElement("rect", { x: "3.5", y: "14", width: "7", height: "7", rx: "2.5", fill: fill, stroke: stroke, strokeWidth: "1.5" }), react_1.default.createElement("rect", { x: "13.5", y: "4", width: "7", height: "7", rx: "2.5", fill: fill, stroke: stroke, strokeWidth: "1.5" }), react_1.default.createElement("rect", { x: "13.5", y: "14", width: "7", height: "7", rx: "2.5", fill: fill, stroke: stroke, strokeWidth: "1.5" })));
}
exports.default = GridViewIcon;
